import DTO from './DTO';

class TravelHistoryDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'trip_started_at',
        type: String,
        validators: [],
        labelKey: 'trip_started_at',
      },
      {
        name: 'trip_ended_at',
        type: String,
        validators: [],
        labelKey: 'trip_ended_at',
      },
      {
        name: 'start_coordinate',
        type: String,
        validators: [],
        labelKey: 'start_coordinate',
      },
      {
        name: 'start_latitude_from',
        type: String,
        validators: [],
        labelKey: 'latitude_from',
      },
      {
        name: 'start_latitude_to',
        type: String,
        validators: [],
        labelKey: 'latitude_to',
      },
      {
        name: 'start_longitude_from',
        type: String,
        validators: [],
        labelKey: 'longitude_from',
      },
      {
        name: 'start_longitude_to',
        type: String,
        validators: [],
        labelKey: 'longitude_to',
      },
      {
        name: 'end_coordinate',
        type: String,
        validators: [],
        labelKey: 'end_coordinate',
      },
      {
        name: 'end_latitude_from',
        type: String,
        validators: [],
        labelKey: 'latitude_from',
      },
      {
        name: 'end_latitude_to',
        type: String,
        validators: [],
        labelKey: 'latitude_to',
      },
      {
        name: 'end_longitude_from',
        type: String,
        validators: [],
        labelKey: 'longitude_from',
      },
      {
        name: 'end_longitude_to',
        type: String,
        validators: [],
        labelKey: 'longitude_to',
      },
      {
        name: 'middle_coordinate',
        type: String,
        validators: [],
        labelKey: 'middle_coordinate',
      },
      {
        name: 'middle_latitude_from',
        type: String,
        validators: [],
        labelKey: 'latitude_from',
      },
      {
        name: 'middle_latitude_to',
        type: String,
        validators: [],
        labelKey: 'latitude_to',
      },
      {
        name: 'middle_longitude_from',
        type: String,
        validators: [],
        labelKey: 'longitude_from',
      },
      {
        name: 'middle_longitude_to',
        type: String,
        validators: [],
        labelKey: 'longitude_to',
      },
      {
        name: 'record_number_lt',
        type: String,
        validators: [],
        labelKey: 'visit.record_number_lt',
      },
      {
        name: 'record_number_rp',
        type: String,
        validators: [],
        labelKey: 'visit.record_number_rp',
      },
      {
        name: 'vehicle_registry_number',
        type: String,
        validators: [],
        labelKey: 'visit.record_number_lt',
      },
      {
        name: 'carrier_registry_number',
        type: String,
        validators: [],
        labelKey: 'visit.record_number_rp',
      },
      {
        name: 'trip_cost',
        type: String,
        validators: [],
        labelKey: 'cost',
      },
      {
        name: 'cost_from',
        type: String,
        validators: [],
        labelKey: 'cost_from',
      },
      {
        name: 'cost_to',
        type: String,
        validators: [],
        labelKey: 'cost_to',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default TravelHistoryDTO;
